import styled from 'styled-components';

import { media } from '@theme/media';
import { CONTAINER_PADDING, CONTAINER_WIDTH } from '@components/blocks/blocks.constants';
import { colonSuffix, paragraphStyles, paragraphTextStyles } from '@components/blocks/blocks.styles';

export const Container = styled.div`
  margin-top: 40px;
  padding: 0 22px;

  ${media.desktop} {
    padding: 0;
    max-width: none;
    display: grid;
    grid-template-columns: calc(50% - ${CONTAINER_WIDTH / 2}px) ${CONTAINER_WIDTH}px auto;
  }
`;

export const Title = styled.h3`
  ${paragraphTextStyles};
  ${colonSuffix};

  ${media.desktop} {
    margin: 0;
    padding-left: ${CONTAINER_PADDING * 0.9}px;
  }
`;

export const Content = styled.div`
  flex-wrap: wrap;

  ${media.desktop} {
    padding: 0 ${CONTAINER_PADDING}px;
  }
`;
